export function transactionMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      objectId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateTransactionId(json) {
  return {
    data: {...json, id: json.objectId,transactionId:json.objectId},
  };
}
export function fixGetManyTransaction(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateTransactionId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function transactionMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, objectId: json.result.objectId},
  };
}